import { call, all, put, takeLatest } from "redux-saga/effects";

import {
  getOnboarding,
  setOnboarding,
  setOnboardingById,
  setOnboardingLoading,
  onboardingTypes as types,
} from "../actions";
import { AxiosResponse } from "axios";
import { EntityIdPayload } from "../../../utils";
import showNotification from "../../../services/notificationService";
import {
  addOnboardingService,
  getOnboardingService,
  getOnboardingByIdService,
  deleteOnboardingByIdService,
  editOnboardingService,
} from "../../../services/educator/onboarding";

export default function* educatorOnboardingSagas() {
  yield all([
    takeLatest(types.ADD_ONBOARDING, handleAddOnboarding),
    takeLatest(types.GET_ONBOARDING, handleGetOnboarding),
    takeLatest(types.GET_ONBOARDING_BY_ID, handleGetOnboardingById),
    takeLatest(types.DELETE_ONBOARDING, handleDeleteOnboarding),
    takeLatest(types.EDIT_ONBOARDING, handleEditOnboarding),
  ]);
}

function* handleAddOnboarding(action: any) {
  yield put(setOnboardingLoading(true));
  const { data }: AxiosResponse = yield call(
    addOnboardingService,
    action.payload.onboarding
  );

  yield put(setOnboardingLoading(false));
  if (data) {
    yield put(getOnboarding());
    showNotification("success", "Onboarding created successfully!");
    action.payload.navigate(`/educator/onboarding`);
  }
}

function* handleGetOnboarding(action: any) {
  const { data }: AxiosResponse = yield call(
    getOnboardingService,
    action?.payload?.query
  );

  if (data) {
    yield put(setOnboarding({ onboardings: data }));
  }
}

function* handleDeleteOnboarding(action: any) {
  const { data }: AxiosResponse = yield call(
    deleteOnboardingByIdService,
    action.payload.id
  );

  if (data) {
    showNotification("success", "Onboarding deleted successfully");
    yield put({ type: types.GET_ONBOARDING });
    action.payload.navigate(`/educator/onboarding`);
  }
}

function* handleGetOnboardingById(action: EntityIdPayload) {
  const { data }: AxiosResponse = yield call(
    getOnboardingByIdService,
    action.payload.id
  );

  if (data) {
    yield put(setOnboardingById({ onboarding: data }));
  }
}

function* handleEditOnboarding(action: any) {
  yield put(setOnboardingLoading(true));
  const { data }: AxiosResponse = yield call(
    editOnboardingService,
    action.payload.id,
    action.payload.onboarding
  );
  yield put(setOnboardingLoading(false));

  if (data) {
    showNotification("success", "Onboarding edited successfully!");
    yield put(getOnboarding());
    action.payload.navigate(`/educator/onboarding`);
  }
}
